/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_AccessInputs */

const en_quick_access = /** @type {(inputs: Quick_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Access`)
};

const es_quick_access = /** @type {(inputs: Quick_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso rápido`)
};

const fr_quick_access = /** @type {(inputs: Quick_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès rapide`)
};

const de_quick_access = /** @type {(inputs: Quick_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellzugriff`)
};

const ja_quick_access = /** @type {(inputs: Quick_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クイックアクセス`)
};

const zh_quick_access = /** @type {(inputs: Quick_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速访问`)
};

const ar_quick_access = /** @type {(inputs: Quick_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وصول سريع`)
};

const id_quick_access = /** @type {(inputs: Quick_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Cepat`)
};

const it_quick_access = /** @type {(inputs: Quick_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso Rapido`)
};

const ru_quick_access = /** @type {(inputs: Quick_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Быстрый доступ`)
};

const pt_quick_access = /** @type {(inputs: Quick_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso Rápido`)
};

const ko_quick_access = /** @type {(inputs: Quick_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빠른 접근`)
};

/**
* | output |
* | --- |
* | "Quick Access" |
*
* @param {Quick_AccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const quick_access = /** @type {((inputs?: Quick_AccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_AccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quick_access(inputs)
	if (locale === "es") return es_quick_access(inputs)
	if (locale === "fr") return fr_quick_access(inputs)
	if (locale === "de") return de_quick_access(inputs)
	if (locale === "ja") return ja_quick_access(inputs)
	if (locale === "zh") return zh_quick_access(inputs)
	if (locale === "ar") return ar_quick_access(inputs)
	if (locale === "id") return id_quick_access(inputs)
	if (locale === "it") return it_quick_access(inputs)
	if (locale === "ru") return ru_quick_access(inputs)
	if (locale === "pt") return pt_quick_access(inputs)
	return ko_quick_access(inputs)
});